import React, {useState, useEffect} from "react";

export default function GiletPrimoRVFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M401.174,222.332l-0.037-0.25l-0.222-0.111c-0.074-0.037-7.577-4.205-13.451-41.046
     c-4.69-29.437,3.446-65.131,7.817-84.308c1.207-5.292,2.076-9.112,2.262-11.046c0.81-8.557-0.911-9.968-1.305-10.185
     c-0.282-0.12-28.432-12.424-49.992-19.543c-21.485-7.095-62.166-24.136-63.891-24.857l-0.291-0.111l-0.12,0.12
     c-1.087,0.379-15.722,5.352-34.261,6.462c-25.357,0.925-43.387-6.092-44.307-6.462l-0.135-0.125l-0.277,0.116
     c-1.721,0.722-42.402,17.762-63.882,24.857c-21.564,7.119-49.715,19.422-50.038,19.566c-0.352,0.194-2.072,1.605-1.263,10.162
     c0.185,1.933,1.055,5.754,2.262,11.046c4.371,19.177,12.512,54.872,7.817,84.308c-5.874,36.842-13.377,41.009-13.441,41.042
     l-0.236,0.111l-0.032,0.254c-0.01,0.079-0.995,8.132-0.583,14.371c1.027,15.653,1.605,31.616,2.169,47.05
     c0.398,10.995,0.81,22.36,1.383,33.521c1.434,28.091,3.099,53.618,5.083,78.041c1.092,13.465,2.299,26.74,3.589,39.446
     c0.716,7.119,1.388,13.395,2.044,19.196c0.079,0.69,0.12,1.665,0.167,2.789c0.161,3.927,0.384,9.306,2.512,10.99
     c0.796,0.629,1.809,0.856,2.622,1.041c16.217,3.649,33.225,5.481,50.76,5.481c5.823,0,11.707-0.199,17.637-0.605
     c18.386-1.263,32.836-5.907,42.957-13.817c10.717-8.377,18.589-19.385,21.596-30.2c0.125-0.448,0.241-0.902,0.352-1.36
     c0.388-0.27,1.683-1.104,3.446-1.657v1.305c0,0.52,0.421,0.941,0.941,0.941h4.119c0.519,0,0.94-0.421,0.94-0.941v-1.364
     c0.997,0.337,2.008,0.877,2.997,1.703c0.116,0.463,0.231,0.92,0.357,1.373c3.007,10.814,10.879,21.823,21.601,30.2
     c10.115,7.91,24.57,12.554,42.956,13.817c5.93,0.407,11.809,0.605,17.637,0.605c17.531,0,34.543-1.832,50.755-5.481
     c0.814-0.185,1.827-0.412,2.623-1.041c2.128-1.684,2.35-7.063,2.512-10.99c0.046-1.129,0.088-2.099,0.166-2.789
     c0.657-5.8,1.328-12.077,2.049-19.196c1.286-12.729,2.494-26.004,3.59-39.446c1.98-24.399,3.645-49.927,5.083-78.041
     c0.569-11.161,0.981-22.526,1.383-33.516c0.56-15.435,1.138-31.398,2.165-47.055C402.169,230.464,401.184,222.411,401.174,222.332z
     "
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M164.628,360.942l-67.629,1.938c-0.352-5.499-1.919-21.994-2.22-25.102
     c5.731-0.37,60.936-3.904,68.943-3.303C164.003,343.394,164.336,352.903,164.628,360.942"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M390.527,337.778c-0.296,3.108-1.864,19.603-2.22,25.102l-67.629-1.939
     c0.296-8.034,0.624-17.535,0.907-26.467C329.596,333.87,384.796,337.408,390.527,337.778"
        />
        <path
          fill={darkenColor}
          d="M256.522,54.769c-3.289,0.809-7.845,1.568-13.372,1.568c-5.523,0-10.079-0.759-13.372-1.568
     c0.138-1.614,0.305-6.591,0.36-8.358c2.184,0.18,4.492,0.315,6.952,0.375c2.461,0.125,4.82,0.185,7.082,0.185
     c4.376,0,8.368-0.217,11.994-0.583C256.222,48.136,256.383,53.145,256.522,54.769"
        />
        <path
          fill={darkenColor}
          d="M280.07,75.098c-0.056,0.171-5.421,17.457-12.119,34.918c-6.591,17.174-12.674,37.022-12.951,37.929
     c-0.365,0.791-6.568,14.709-8.358,46.912c-1.827,32.938-0.546,150.564-0.532,151.762c0.342,8.127,0.305,16.402,0.268,24.399
     c-0.037,8.011-0.074,16.29,0.268,24.446c0.125,2.956,0.153,6.022,0.18,8.992c0.065,7.465,0.139,15.153,1.721,22.452
     c-4.765-3.229-9.76-1.05-11.823,0.139c1.614-7.341,1.688-15.079,1.753-22.591c0.028-2.97,0.056-6.036,0.18-8.992
     c0.342-8.155,0.305-16.439,0.268-24.45c-0.037-7.997-0.074-16.268,0.268-24.413c0.014-1.18,1.296-118.805-0.532-151.743
     c-1.79-32.203-7.993-46.121-8.353-46.912c-0.278-0.907-6.365-20.754-12.956-37.929c-6.697-17.461-12.063-34.747-12.123-34.932
     c-0.074-0.213-6.406-18.724-3.455-36.268c1.989,1.23,8.867,4.935,21.841,6.846c-0.056,1.101-0.365,7.498-0.458,8.423
     c-0.111,1.092,2.812,3.992,4.565,5.625l0.069,0.069l0.093,0.028c0.064,0.023,6.383,2.174,15.231,2.188h0.065
     c8.849-0.014,15.172-2.165,15.232-2.188l0.092-0.028l0.074-0.069c1.748-1.633,4.672-4.533,4.561-5.625
     c-0.014-0.148-0.032-0.439-0.055-0.823l-0.402-7.738c12.142-2.017,18.89-5.56,20.847-6.721
     C286.49,56.346,280.149,74.876,280.07,75.098"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M357.663,162.542c-0.139,8.27-0.315,16.652-0.523,25.024l-70.973-3.178l1.517-24.982l7.031,0.315
     C295.321,159.748,352.357,162.302,357.663,162.542"
        />
        <path
          fill="#010101"
          d="M185.04,139.512c-0.009-0.291-0.134-0.564-0.351-0.763c-0.213-0.199-0.5-0.301-0.786-0.287
     c-3.016,0.134-13.123,0.606-16.619,1.05c-0.588,0.079-1.004,0.597-0.944,1.189c0.13,1.309,0.444,4.584,0.587,6.614
     c0.037,0.574,0.514,1.013,1.083,1.013h0.014c4.44-0.06,13.557-0.763,16.249-0.976c0.583-0.046,1.023-0.537,0.999-1.124
     L185.04,139.512z M184.198,146.431c-2.683,0.213-11.776,0.911-16.189,0.971c-0.088,0-0.153-0.06-0.162-0.148
     c-0.138-2.049-0.458-5.329-0.587-6.647c-0.009-0.088,0.05-0.167,0.139-0.176c3.552-0.453,14.408-0.953,16.545-1.045h0.009
     c0.056,0,0.093,0.023,0.111,0.042c0.019,0.018,0.05,0.056,0.05,0.116l0.231,6.716C184.351,146.348,184.286,146.422,184.198,146.431
     "
        />
        <path
          fill="#010101"
          d="M357.381,161.714l-70.46-3.155l-1.591,26.194c-0.68,11.221-1.346,22.184-1.355,22.29
     c-0.305,5.056-0.652,10.782-0.772,16.397c-0.093,4.325-0.037,8.654,0.176,13.243l0.01,0.208c0.194,4.353,0.397,8.853,3.14,12.382
     c2.225,2.863,5.504,4.14,7.863,4.704c2.605,0.624,5.333,0.735,7.97,0.842c0.958,0.042,1.947,0.083,2.905,0.148
     c7.544,0.509,15.19,0.763,22.776,0.763c1.17,0,2.345-0.005,3.515-0.018c0.564-0.005,1.129-0.005,1.693-0.005h0.43
     c4.251,0,8.636-0.037,12.669-2.188c3.58-1.915,6.268-5.204,7.567-9.269c2.364-7.405,2.845-16.235,3.196-22.683
     c0.278-5.056,0.352-10.195,0.421-15.162c0.042-2.859,0.083-5.819,0.162-8.724c0.324-11.841,0.592-23.793,0.786-35.528
     C358.481,161.76,358.357,161.756,357.381,161.714 M356.881,197.659c-0.083,2.914-0.125,5.874-0.162,8.738
     c-0.069,4.959-0.143,10.088-0.416,15.125c-0.352,6.406-0.832,15.176-3.164,22.484c-1.235,3.858-3.779,6.98-7.174,8.793
     c-3.922,2.095-8.099,2.091-12.498,2.095c-0.638,0-1.281,0-1.92,0.005c-8.714,0.093-17.54-0.157-26.226-0.745
     c-0.972-0.065-1.966-0.106-2.928-0.143c-2.6-0.106-5.287-0.217-7.813-0.823c-2.234-0.537-5.329-1.735-7.41-4.413
     c-2.581-3.326-2.779-7.697-2.974-11.92l-0.01-0.208c-0.208-4.57-0.264-8.881-0.171-13.187c0.12-5.597,0.467-11.319,0.772-16.365
     h-0.018c0.056-0.62,0.254-3.848,1.351-21.892l71.001,3.178C357.048,191.474,356.964,194.569,356.881,197.659 M357.14,187.566
     l-70.973-3.178l1.517-24.982l7.031,0.315c0.606,0.028,57.643,2.581,62.948,2.822C357.524,170.812,357.348,179.194,357.14,187.566"
        />
        <rect x="241.918" y="214.932" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="212.794" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="210.656" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="213.874" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="211.736" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="209.598" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="232.049" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="229.911" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="227.773" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="225.635" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="223.498" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="221.36" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="219.222" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="217.084" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="230.99" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="228.853" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="226.715" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="224.578" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="222.44" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="220.302" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="218.164" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="216.026" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="249.161" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="247.023" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="244.885" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="242.747" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="240.609" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="238.472" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="236.334" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="234.196" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="248.102" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="245.964" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="243.826" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="241.689" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="239.551" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="237.414" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="235.276" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="233.138" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="266.25" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="264.112" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="261.975" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="259.837" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="257.699" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="255.562" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="253.423" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="251.286" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="265.192" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="263.055" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="260.917" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="258.779" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="256.641" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="254.503" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="252.366" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="250.228" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="283.346" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="281.208" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="279.07" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="276.933" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="274.795" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="272.657" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="270.519" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="268.381" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="282.288" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="280.15" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="278.012" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="275.874" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="273.737" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="271.599" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="269.461" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="267.323" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="300.463" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="298.325" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="296.187" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="294.05" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="291.911" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="289.774" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="287.636" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="285.498" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="299.405" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="297.267" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="295.129" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="292.991" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="290.854" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="288.716" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="286.578" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="284.44" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="317.574" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="315.437" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="313.299" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="311.161" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="309.024" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="306.885" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="304.748" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="302.61" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="316.516" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="314.379" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="312.241" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="310.103" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="307.965" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="305.828" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="303.69" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="301.552" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="334.7" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="332.562" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="330.425" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="328.287" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="326.149" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="324.011" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="321.874" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="319.736" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="333.642" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="331.504" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="329.366" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="327.229" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="325.091" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="322.953" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="320.816" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="318.678" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="351.796" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="349.658" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="347.52" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="345.382" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="343.245" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="341.107" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="338.969" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="336.832" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="350.737" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="348.6" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="346.462" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="344.325" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="342.187" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="340.049" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="337.911" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="335.773" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="368.913" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="366.775" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="364.637" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="362.499" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="360.362" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="358.224" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="356.086" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="353.949" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="367.854" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="365.717" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="363.579" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="361.442" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="359.304" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="357.166" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="355.028" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="352.89" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="386.024" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="383.887" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="381.749" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="379.611" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="377.473" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="375.336" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="373.198" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="371.06" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="384.966" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="382.828" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="380.691" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="378.553" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="376.415" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="374.278" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="372.14" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="370.002" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="403.114" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="400.976" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="398.838" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="396.701" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="394.563" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="392.425" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="390.287" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="388.15" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="402.056" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="399.918" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="397.78" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="395.642" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="393.505" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="391.367" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="389.23" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="387.092" fill="#010101" width="3.207" height="0.923" />
        <rect x="241.918" y="420.21" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="418.072" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="415.934" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="413.796" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="411.658" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="409.521" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="407.383" fill="#010101" width="3.206" height="0.923" />
        <rect x="241.918" y="405.245" fill="#010101" width="3.206" height="0.923" />
        <rect x="240.604" y="419.151" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="417.013" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="414.876" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="412.738" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="410.601" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="408.463" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="406.325" fill="#010101" width="3.207" height="0.923" />
        <rect x="240.604" y="404.187" fill="#010101" width="3.207" height="0.923" />
        <path
          fill="#010101"
          d="M244.941,179.099c-0.015-0.451-0.398-0.824-0.849-0.824h-0.014v0.867h0.144l0.321,3.906h-3.499l0.321-3.906
     h0.144v-0.867h-0.067c-0.455,0-0.839,0.374-0.848,0.824l-0.489,28.887c-0.015,0.451,0.345,0.824,0.8,0.824h3.777
     c0.455,0,0.815-0.374,0.8-0.824L244.941,179.099z M241.202,185.861c0-0.307,0.249-0.551,0.551-0.551h2.061
     c0.302,0,0.551,0.244,0.551,0.551v2.056c0,0.307-0.249,0.551-0.551,0.551h-2.061c-0.302,0-0.551-0.245-0.551-0.551V185.861z
      M242.793,207.87c-1.007,0-1.822-0.815-1.822-1.822c0-1.002,0.815-1.816,1.822-1.816c1.007,0,1.822,0.815,1.822,1.816
     C244.614,207.055,243.799,207.87,242.793,207.87"
        />
        <rect x="241.829" y="175.823" fill="#010101" width="1.927" height="4.745" />
        <path
          fill="#010101"
          d="M246.967,177c0-2.187-1.773-3.96-3.96-3.96h-0.427c-2.187,0-3.961,1.773-3.961,3.96
     c0,0.406,0.062,0.798,0.176,1.167h0c0.001,0.003,0.001,0.006,0.003,0.009c0,0.001,0,0.002,0.001,0.003
     c0.392,1.032,0.389,2.536,0.389,3.976h0.009c0.05,0.792,0.427,1.494,0.996,1.975l0.169-5.347c0.015-0.471,0.437-0.856,0.938-0.856
     h0.21v-2.44h2.569v2.44h0.15c0.501,0,0.924,0.385,0.941,0.856l0.187,5.379c0.591-0.482,0.984-1.198,1.035-2.008h0.006
     c0-0.038,0-0.077,0-0.115c0-0.021,0.002-0.042,0.002-0.063c0-0.021-0.002-0.04-0.002-0.061c0.001-1.334,0.021-2.694,0.366-3.665
     C246.893,177.857,246.967,177.437,246.967,177"
        />
        <rect x="240.826" y="421.415" fill="#010101" width="4.099" height="1.811" />
        <path
          fill="#010101"
          d="M244.934,428.906h-4.119c-0.519,0-0.941-0.421-0.941-0.941v-4.458h6v4.458
     C245.875,428.485,245.454,428.906,244.934,428.906"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M85.572,231.983c3.287-4.097,8.185-11.168,12.393-21.17c3.309-7.865,4.483-16.709,5.456-25.121
     c1.282-11.089,2.093-22.265,1.652-33.432c-0.437-11.078-2.498-21.949-4.591-32.81c-0.53-2.754-1.062-5.508-1.568-8.267
     c-1.472-8.012-2.963-16.02-4.478-24.025c0,0-1.414-6.149-0.418-12.101"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M99.901,461.513c1.165,0.514,5.04,1.228,5.071,1.234c15.709,2.9,31.653,5.072,48.791,5.829c5.685,0,11.499-0.201,17.281-0.597
     c17.254-1.179,30.685-5.434,39.918-12.646c8.691-6.797,16.66-16.497,19.666-27.314c2.059-7.409,2.132-15.736,2.204-23.784
     c0.021-2.682,0.046-6.02,0.179-9.184l0.537-48.771l0.005-0.422c0.205-19.906,1.142-120.736-0.535-150.869
     c-1.722-30.992-7.645-44.432-7.843-44.873l-0.052-0.107l-0.162-0.404l-0.059-0.194c-0.061-0.198-6.201-20.303-12.829-37.581
     c-6.466-16.855-11.659-33.407-12.212-35.187c-0.497-1.46-6.31-19.1-3.964-36.9c0,0,0.173-3.685,0.693-4.803"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M169.145,145.99c-0.115-1.421-0.269-3.081-0.388-4.31c3.676-0.349,10.825-0.703,14.014-0.852l0.148,4.311
     C179.706,145.387,173.205,145.864,169.145,145.99z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M106.436,459.364c-0.499-5.58-1.028-12.257-1.541-18.727l-0.129-1.629c-1.024-13.011-1.991-25.3-2.773-30.336
     c-1.145-7.373-3.18-39.064-3.273-43.523"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M163.598,363.294c0.291,7.878,0.533,14.049,0.639,16.281c0.19,3.907,3.966,72.789,4.636,84.988"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M98.386,361.912c-0.445-5.735-1.401-18.922-1.839-23.539"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M162.139,335.135c0.164,0-0.04,1.584,0.112,1.585c0.209,6.481,0.675,15.269,0.967,23.392"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2997"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     102.68,338.52 101.83,340.344 101.958,338.561 100.633,340.402 100.761,338.619 99.674,340.451 99.801,338.668 98.716,340.499 
     98.843,338.718 97.757,340.549 97.884,338.767 96.8,340.597 96.926,338.816 95.843,340.646 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2997"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     162.678,335.404 161.828,337.228 161.956,335.444 160.631,337.285 160.759,335.503 159.672,337.335 159.799,335.552 
     158.714,337.383 158.841,335.601 157.756,337.432 157.882,335.65 156.798,337.481 156.924,335.7 155.841,337.53 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M282.157,36.258c0,0-15.443,6.543-34.926,7.709c-26.314,0.959-44.61-7.709-44.61-7.709"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M399.735,231.983c-3.287-4.097-8.185-11.168-12.393-21.17c-3.309-7.865-4.482-16.709-5.455-25.121
     c-1.283-11.089-2.093-22.265-1.653-33.432c0.437-11.078,2.498-21.949,4.591-32.81c0.53-2.754,1.062-5.508,1.569-8.267
     c1.471-8.012,2.963-16.02,4.477-24.025c0,0,1.414-6.149,0.418-12.101"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M385.406,461.513c-1.165,0.514-5.04,1.228-5.071,1.234c-15.709,2.9-31.653,5.072-48.791,5.829c-5.685,0-11.499-0.201-17.281-0.597
     c-17.254-1.179-30.685-5.434-39.918-12.646c-8.691-6.797-16.659-16.497-19.666-27.314c-2.059-7.409-2.132-15.736-2.204-23.784
     c-0.021-2.682-0.046-6.02-0.179-9.184l-0.538-48.771l-0.005-0.422c-0.205-19.906-1.143-120.736,0.535-150.869
     c1.722-30.992,7.645-44.432,7.843-44.873l0.052-0.107l0.162-0.404l0.059-0.194c0.061-0.198,6.201-20.303,12.829-37.581
     c6.466-16.855,11.659-33.407,12.212-35.187c0.497-1.46,6.31-19.1,3.964-36.9c0,0-0.173-3.685-0.693-4.803"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M378.871,459.364c0.499-5.58,1.028-12.257,1.541-18.727l0.129-1.629c1.024-13.011,1.991-25.3,2.773-30.336
     c1.145-7.373,3.18-39.064,3.273-43.523"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M321.709,363.294c-0.291,7.878-0.533,14.049-0.639,16.281c-0.19,3.907-3.966,72.789-4.636,84.988"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M386.922,361.912c0.445-5.735,1.401-18.922,1.839-23.539"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M323.168,335.135c-0.164,0,0.04,1.584-0.111,1.585c-0.209,6.481-0.675,15.269-0.968,23.392"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2997"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     382.626,338.52 383.477,340.344 383.348,338.561 384.674,340.402 384.546,338.619 385.633,340.451 385.505,338.668 
     386.591,340.499 386.464,338.718 387.549,340.549 387.422,338.767 388.507,340.597 388.381,338.816 389.464,340.646 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2997"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     322.628,335.404 323.479,337.228 323.35,335.444 324.676,337.285 324.547,335.503 325.634,337.335 325.507,335.552 
     326.593,337.383 326.466,335.601 327.551,337.432 327.424,335.65 328.509,337.481 328.382,335.7 329.466,337.53 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M355.945,189.706c-0.063,2.542-0.131,5.084-0.199,7.623l-0.008,0.293c-0.082,2.887-0.124,5.788-0.162,8.753
     c-0.065,4.69-0.14,10.009-0.414,15.073c-0.347,6.329-0.823,14.998-3.1,22.138c-1.124,3.513-3.435,6.351-6.506,7.99
     c-3.583,1.914-7.542,1.923-11.733,1.932h-0.115c-0.638,0-1.285,0-1.926,0.005c-1.179,0.012-2.357,0.018-3.534,0.018
     c-7.528,0-15.128-0.255-22.589-0.76c-1.022-0.068-2.068-0.111-2.968-0.146c-2.527-0.103-5.144-0.21-7.541-0.786
     c-2.017-0.484-4.806-1.557-6.638-3.915c-2.309-2.974-2.499-7.118-2.683-11.126l-0.005-0.185c-0.211-4.541-0.268-8.824-0.175-13.123
     c0.119-5.542,0.463-11.237,0.767-16.26l0.003-0.051l-0.003,0.036c0.016-0.218,0.098-1.56,0.734-12.062l0.518-8.503"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          x1="287.781"
          y1="183.065"
          x2="289.13"
          y2="160.853"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.5033"
          strokeMiterlimit="10"
          strokeDasharray="1.4945,1.4931"
          d="
     M356.396,163.867c-0.124,7.21-0.28,14.68-0.464,22.249"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2669"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     294.892,160.523 294.012,162.086 294.247,160.51 292.944,162.056 293.179,160.48 292.088,162.034 292.323,160.458 291.233,162.013 
     291.467,160.437 290.377,161.99 290.611,160.415 289.523,161.969 289.756,160.394 288.669,161.947 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2669"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     356.396,163.15 355.515,164.714 355.751,163.137 354.447,164.683 354.683,163.107 353.592,164.662 353.827,163.086 352.736,164.64 
     352.971,163.064 351.881,164.618 352.115,163.043 351.027,164.596 351.26,163.021 350.173,164.574 	"
        />
        <path
          fill="#010101"
          d="M401.165,222.372l-0.037-0.25l-0.222-0.111c-0.074-0.037-7.577-4.205-13.451-41.046
     c-4.69-29.437,3.446-65.131,7.817-84.308c1.207-5.292,2.076-9.112,2.262-11.046c0.809-8.557-0.911-9.968-1.305-10.185
     c-0.282-0.12-28.432-12.424-49.992-19.543c-21.485-7.095-62.166-24.136-63.891-24.857l-0.291-0.111l-0.12,0.12
     c-1.087,0.379-15.722,5.352-34.261,6.462c-25.357,0.925-43.387-6.092-44.307-6.462l-0.135-0.125l-0.277,0.116
     c-1.721,0.722-42.402,17.762-63.882,24.857c-21.564,7.119-49.715,19.422-50.038,19.566c-0.352,0.194-2.072,1.605-1.263,10.162
     c0.185,1.933,1.055,5.754,2.262,11.046c4.371,19.177,12.512,54.872,7.817,84.308c-5.874,36.842-13.377,41.009-13.441,41.042
     l-0.236,0.111l-0.032,0.254c-0.01,0.079-0.994,8.132-0.583,14.371c1.027,15.653,1.605,31.616,2.169,47.05
     c0.398,10.995,0.809,22.36,1.383,33.521c1.434,28.09,3.099,53.618,5.083,78.041c1.092,13.465,2.299,26.74,3.589,39.446
     c0.716,7.119,1.388,13.395,2.044,19.196c0.079,0.69,0.12,1.665,0.167,2.789c0.161,3.927,0.384,9.306,2.512,10.99
     c0.796,0.629,1.809,0.856,2.622,1.041c16.217,3.65,33.225,5.481,50.76,5.481c5.823,0,11.707-0.199,17.637-0.605
     c18.386-1.263,32.836-5.907,42.957-13.817c10.717-8.377,18.589-19.385,21.596-30.2c0.125-0.448,0.241-0.902,0.352-1.36
     c0.93-0.647,7.017-4.547,12.442-0.013c0.116,0.463,0.231,0.92,0.357,1.373c3.007,10.814,10.879,21.823,21.601,30.2
     c10.115,7.91,24.57,12.554,42.956,13.817c5.93,0.407,11.809,0.605,17.637,0.605c17.531,0,34.543-1.832,50.755-5.481
     c0.814-0.185,1.827-0.412,2.623-1.041c2.128-1.684,2.35-7.063,2.512-10.99c0.046-1.129,0.088-2.1,0.166-2.789
     c0.657-5.8,1.328-12.077,2.049-19.196c1.286-12.729,2.494-26.004,3.59-39.446c1.98-24.399,3.645-49.927,5.083-78.041
     c0.569-11.161,0.981-22.526,1.383-33.516c0.56-15.435,1.138-31.398,2.165-47.055C402.16,230.504,401.175,222.451,401.165,222.372
      M203.436,32.053c2.807,1.059,18.206,6.453,39.645,6.453c1.517,0,3.067-0.028,4.639-0.088c17.475-1.045,31.509-5.5,34.145-6.383
     c0.63,1.896,1.119,3.834,1.49,5.791c-2.012,1.258-16.499,9.538-46.222,8.039l-0.023,0.458l0.009-0.463
     c-22.507-0.574-33.451-6.938-35.167-8.03C202.321,35.878,202.807,33.945,203.436,32.053 M243.118,57.262h0.065
     c10.065-0.009,16.989-2.493,19.02-3.321c0.009,0.093,0.014,0.167,0.018,0.222c-0.032,0.555-2.183,2.914-4.2,4.801
     c-0.796,0.259-6.739,2.1-14.871,2.105c-8.127-0.005-14.071-1.846-14.871-2.105c-2.017-1.887-4.168-4.246-4.2-4.787
     c0.005-0.06,0.014-0.139,0.019-0.236C226.128,54.769,233.053,57.252,243.118,57.262 M224.162,52.965
     c0.125-2.114,0.32-6.11,0.37-7.169c1.48,0.203,3.048,0.379,4.681,0.532c-0.087,2.775-0.235,6.799-0.337,8.21
     C226.406,53.876,224.782,53.228,224.162,52.965 M229.778,54.769c0.139-1.614,0.305-6.591,0.36-8.358
     c2.184,0.18,4.492,0.315,6.953,0.375c2.461,0.125,4.82,0.185,7.081,0.185c4.376,0,8.368-0.217,11.994-0.583
     c0.056,1.748,0.217,6.758,0.356,8.381c-3.289,0.809-7.845,1.568-13.372,1.568C237.627,56.337,233.071,55.578,229.778,54.769
      M257.087,46.29c1.633-0.18,3.196-0.384,4.676-0.615c0.037,0.823,0.245,5.088,0.379,7.29c-0.62,0.264-2.248,0.911-4.714,1.573
     C257.323,53.117,257.174,49.065,257.087,46.29 M85.033,222.706c1.383-0.93,8.243-7.179,13.728-41.592
     c4.723-29.617-3.441-65.423-7.826-84.66c-1.198-5.259-2.063-9.057-2.243-10.93c-0.717-7.581,0.642-9.117,0.805-9.269
     c0.374-0.167,2.798-1.216,6.55-2.803c-1.559,6.388,0.037,13.497,0.102,13.793c1.457,7.688,2.965,15.773,4.477,24.025
     c0.477,2.581,0.981,5.199,1.466,7.734l0.107,0.537c1.938,10.07,4.14,21.485,4.584,32.739c0.379,9.713-0.144,20.315-1.651,33.359
     c-1.018,8.798-2.197,17.332-5.421,24.996c-5.814,13.812-13.016,22.073-15.301,24.483C84.251,229.861,84.894,223.917,85.033,222.706
      M235.185,429.432c-2.951,10.63-10.708,21.458-21.277,29.719c-9.968,7.789-24.251,12.373-42.448,13.618
     c-23.692,1.623-46.616-0.01-68.129-4.853c-0.916-0.208-1.666-0.402-2.253-0.865c-1.795-1.42-2.012-6.767-2.16-10.3
     c-0.046-1.148-0.088-2.133-0.171-2.859c-0.657-5.791-1.328-12.068-2.044-19.182c-1.291-12.702-2.498-25.967-3.589-39.428
     c-1.984-24.413-3.645-49.932-5.083-78.018c-0.569-11.152-0.981-22.512-1.383-33.502c-0.56-15.439-1.138-31.412-2.165-47.078
     c-0.01-0.097-0.014-0.199-0.018-0.296c1.216-1.212,9.547-9.824,16.097-25.394c3.27-7.78,4.464-16.383,5.49-25.25
     c1.512-13.09,2.04-23.738,1.651-33.502c-0.445-11.323-2.65-22.776-4.598-32.878l-0.102-0.537c-0.491-2.53-0.994-5.148-1.466-7.729
     c-1.517-8.252-3.02-16.333-4.482-24.043c-0.018-0.079-1.735-7.72,0.064-14.057c9.903-4.168,27.596-11.402,42.24-16.235
     c15.403-5.088,40.634-15.269,54.368-20.907c-0.62,2.886-0.981,7.248-0.999,7.456c-1.193,16.874,3.89,32.48,4.468,34.196
     c0.227,0.722,5.597,17.951,12.257,35.32c6.614,17.239,12.706,37.193,12.766,37.392l0.102,0.328l0.241,0.597l0.065,0.134
     c0.241,0.546,5.916,13.691,7.595,43.863c1.67,30.024,0.731,130.794,0.527,150.689l-0.541,49.104
     c-0.134,3.206-0.157,6.564-0.18,9.279c-0.069,7.867-0.139,16.004-2.105,23.062c-2.535,9.131-9.353,18.562-18.701,25.871
     c-9.126,7.127-22.346,11.48-38.243,12.586c-0.375-6.786-4.505-82.172-4.699-86.265c-0.222-4.607-1.045-26.435-1.647-45.427
     l-0.014-0.398l-0.394-0.046c-6.744-0.819-67.402,3.117-69.983,3.288l-0.472,0.028l0.042,0.476
     c0.689,7.138,2.442,25.917,2.331,27.119c-0.139,1.54,2.04,36.439,3.293,44.516c0.767,4.945,1.729,17.193,2.752,30.168
     c0.601,7.614,1.221,15.486,1.799,21.8l0.032,0.351l0.352,0.06c27.716,4.769,45.991,5.726,56.194,5.726
     c6.744,0,9.964-0.421,10.042-0.43l0.278-0.037l0.005,0.005c16.148-1.101,29.603-5.527,38.905-12.789
     c9.496-7.429,16.43-17.036,19.02-26.352c1.994-7.179,2.068-15.375,2.137-23.322c0.023-2.692,0.046-6.041,0.18-9.246l0.541-49.118
     c0.204-19.899,1.142-120.697-0.532-150.749c-1.683-30.338-7.423-43.632-7.674-44.196l-0.277-0.657l-0.088-0.287
     c-0.06-0.199-6.161-20.186-12.785-37.457c-6.651-17.341-12.012-34.538-12.244-35.274c-0.578-1.707-5.601-17.151-4.422-33.84
     c0.005-0.056,0.43-5.208,1.124-7.96c3.58-1.471,6.268-2.59,7.614-3.155c-6.166,19.381,1.882,42.883,1.961,43.105
     c0.056,0.176,5.431,17.489,12.142,34.978c6.698,17.461,12.877,37.698,12.938,37.896l0.028,0.069
     c0.064,0.134,6.457,13.761,8.28,46.592c1.827,32.906,0.546,150.499,0.531,151.669c-0.342,8.15-0.305,16.434-0.268,24.441
     c0.037,8.002,0.074,16.272-0.268,24.404c-0.124,2.974-0.153,6.05-0.18,9.025C237.479,412.803,237.405,421.444,235.185,429.432
      M97.055,363.806l67.606-1.938c0.315,8.557,0.583,15.31,0.694,17.642c0.194,4.107,4.347,79.836,4.704,86.321
     c-3.09,0.323-23.201,1.914-65.178-5.278c-0.574-6.244-1.18-13.964-1.767-21.434c-1.023-12.989-1.989-25.26-2.762-30.233
     c-1.248-8.048-3.427-42.762-3.288-44.294C97.077,364.472,97.073,364.199,97.055,363.806 M96.999,362.88
     c-0.351-5.499-1.919-21.994-2.22-25.102c5.73-0.371,60.936-3.904,68.942-3.303c0.283,8.918,0.616,18.428,0.907,26.467
     L96.999,362.88z M236.725,427.045c1.614-7.341,1.688-15.079,1.753-22.591c0.027-2.97,0.055-6.036,0.18-8.991
     c0.343-8.155,0.305-16.439,0.268-24.451c-0.037-7.997-0.074-16.268,0.268-24.413c0.014-1.18,1.296-118.805-0.531-151.743
     c-1.79-32.203-7.993-46.121-8.354-46.912c-0.278-0.907-6.365-20.754-12.956-37.929c-6.698-17.461-12.063-34.747-12.123-34.932
     c-0.074-0.213-6.406-18.724-3.455-36.268c1.989,1.23,8.867,4.935,21.841,6.846c-0.055,1.101-0.365,7.498-0.458,8.423
     c-0.111,1.092,2.812,3.992,4.565,5.625l0.069,0.069l0.093,0.028c0.065,0.023,6.383,2.174,15.232,2.188h0.065
     c8.848-0.014,15.171-2.165,15.232-2.188l0.092-0.028l0.074-0.069c1.748-1.633,4.671-4.533,4.561-5.625
     c-0.014-0.148-0.032-0.439-0.056-0.823l-0.402-7.738c12.142-2.017,18.89-5.56,20.847-6.721c2.96,17.544-3.381,36.074-3.46,36.296
     c-0.056,0.171-5.421,17.457-12.119,34.918c-6.591,17.174-12.673,37.022-12.951,37.929c-0.365,0.791-6.568,14.709-8.358,46.912
     c-1.827,32.938-0.546,150.564-0.532,151.762c0.342,8.127,0.305,16.402,0.268,24.399c-0.037,8.011-0.074,16.291,0.268,24.446
     c0.125,2.955,0.153,6.022,0.18,8.991c0.065,7.465,0.139,15.153,1.721,22.452C243.783,423.678,238.788,425.857,236.725,427.045
      M400.828,236.684c-1.027,15.666-1.61,31.639-2.17,47.083c-0.402,10.985-0.814,22.346-1.383,33.498
     c-1.438,28.104-3.099,53.623-5.083,78.018c-1.092,13.437-2.299,26.703-3.585,39.428c-0.722,7.114-1.393,13.391-2.05,19.182
     c-0.083,0.726-0.12,1.711-0.171,2.859c-0.143,3.533-0.365,8.88-2.16,10.3c-0.583,0.463-1.333,0.657-2.253,0.865
     c-21.514,4.843-44.437,6.476-68.129,4.853c-18.197-1.245-32.481-5.829-42.448-13.618c-10.569-8.261-18.322-19.089-21.277-29.719
     c-2.22-7.988-2.294-16.629-2.369-24.986c-0.027-2.975-0.055-6.051-0.18-9.025c-0.342-8.127-0.305-16.402-0.268-24.399
     c0.037-8.011,0.074-16.291-0.268-24.432c-0.014-1.184-1.295-118.777,0.532-151.683c1.822-32.795,8.215-46.458,8.279-46.592
     l0.028-0.069c0.06-0.199,6.24-20.435,12.942-37.896c6.712-17.489,12.082-34.802,12.133-34.959
     c0.083-0.241,8.132-23.743,1.966-43.123c1.351,0.564,4.038,1.684,7.618,3.155c0.694,2.752,1.119,7.905,1.124,7.956
     c1.18,16.693-3.848,32.138-4.431,33.854c-0.222,0.726-5.582,17.924-12.239,35.265c-6.624,17.272-12.725,37.258-12.785,37.452
     l-0.074,0.254l-0.217,0.541l-0.079,0.167c-0.241,0.55-5.981,13.844-7.669,44.183c-1.674,30.052-0.735,130.85-0.532,150.753
     l0.541,49.127c0.134,3.192,0.162,6.54,0.18,9.251c0.069,7.928,0.143,16.124,2.137,23.303c2.59,9.316,9.524,18.923,19.025,26.352
     c9.302,7.262,22.753,11.688,38.905,12.789v-0.005l0.282,0.037c0.079,0.009,3.293,0.43,10.037,0.43
     c10.203,0,28.484-0.957,56.195-5.726l0.352-0.06l0.032-0.351c0.578-6.314,1.198-14.186,1.8-21.805
     c1.022-12.97,1.984-25.218,2.752-30.163c1.253-8.081,3.432-42.975,3.293-44.516c-0.111-1.203,1.647-19.982,2.331-27.119
     l0.047-0.476l-0.477-0.028c-2.581-0.171-63.239-4.107-69.983-3.288l-0.393,0.046l-0.014,0.398
     c-0.601,19.038-1.425,40.852-1.642,45.427c-0.194,4.093-4.329,79.479-4.704,86.265c-15.893-1.106-29.117-5.458-38.244-12.586
     c-9.348-7.309-16.166-16.74-18.7-25.871c-1.961-7.058-2.036-15.195-2.105-23.081c-0.019-2.697-0.047-6.055-0.18-9.247
     l-0.541-49.118c-0.204-19.894-1.142-120.665,0.532-150.689c1.674-30.172,7.349-43.318,7.585-43.849l0.324-0.782l0.092-0.291
     c0.056-0.199,6.147-20.153,12.761-37.392c6.661-17.369,12.036-34.599,12.257-35.311c0.583-1.725,5.662-17.332,4.469-34.21
     c-0.019-0.208-0.375-4.565-0.995-7.452c13.733,5.638,38.965,15.824,54.364,20.907c14.644,4.834,32.337,12.068,42.24,16.235
     c1.799,6.332,0.083,13.978,0.06,14.075c-1.462,7.72-2.965,15.805-4.477,24.025c-0.472,2.576-0.976,5.19-1.462,7.72l-0.107,0.546
     c-1.947,10.102-4.153,21.555-4.597,32.878c-0.384,9.764,0.139,20.412,1.656,33.502c1.027,8.872,2.216,17.475,5.485,25.25
     c6.554,15.569,14.88,24.182,16.102,25.394C400.837,236.485,400.832,236.587,400.828,236.684 M388.255,363.806
     c-0.018,0.393-0.023,0.667-0.013,0.786c0.139,1.526-2.036,36.241-3.284,44.294c-0.772,4.972-1.739,17.244-2.761,30.233
     c-0.592,7.47-1.198,15.19-1.767,21.434c-41.981,7.197-62.092,5.601-65.182,5.278c0.357-6.485,4.51-82.214,4.704-86.321
     c0.111-2.317,0.38-9.071,0.694-17.642L388.255,363.806z M320.678,360.942c0.296-8.034,0.624-17.535,0.907-26.467
     c8.011-0.606,63.212,2.933,68.942,3.303c-0.296,3.108-1.864,19.603-2.22,25.102L320.678,360.942z M400.902,235.116
     c-2.285-2.41-9.492-10.671-15.301-24.483c-3.224-7.664-4.408-16.194-5.426-24.996c-1.508-13.044-2.031-23.641-1.647-33.359
     c0.444-11.254,2.641-22.669,4.584-32.739l0.102-0.546c0.49-2.53,0.989-5.148,1.466-7.725c1.508-8.224,3.016-16.305,4.473-24.006
     c0.074-0.315,1.67-7.424,0.111-13.812c3.751,1.587,6.17,2.637,6.545,2.803c0.162,0.153,1.522,1.688,0.805,9.269
     c-0.18,1.873-1.045,5.671-2.243,10.93c-4.385,19.237-12.549,55.043-7.826,84.66c5.485,34.414,12.35,40.663,13.728,41.592
     C400.411,223.917,401.059,229.861,400.902,235.116"
        />
      </g>
    </svg>
  );
}
